import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
// import $ from 'jquery';
// import Popper from 'popper.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from "react-dnd-html5-backend";

// Benign ResizeObserver noise — capture-phase so CRA overlay ignores it.
const isResizeObserverLoopError = (message = "") =>
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/i.test(
    String(message || "")
  );

window.addEventListener(
  "error",
  (event) => {
    if (isResizeObserverLoopError(event?.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true
);

if (typeof window.ResizeObserver !== "undefined") {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      let scheduled = false;
      let latestEntries = [];
      let latestObserver = null;
      super((entries, observer) => {
        latestEntries = entries;
        latestObserver = observer;
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          callback(latestEntries, latestObserver);
        });
      });
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   
    <DndProvider backend={HTML5Backend}>
      <App />
    </DndProvider>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
